import { sliderClasses } from '@mui/material'
import { alpha, type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'

export const overridesSlider = (theme: Theme): ComponentsOverrides['MuiSlider'] => ({
  root: {
    [`&.${sliderClasses.disabled}`]: {
      [`& .${sliderClasses.rail}`]: {
        color: alpha(theme.customPalette.onElements.ripple || '', 0.3),
      },
      [`& .${sliderClasses.track}`]: {
        color: theme.palette.text.disabled,
      },
    },
    height: rem(7),
  },
  rail: {
    borderRadius: RADIUS_1,
    color: theme.palette.text.secondary,
    opacity: 1,
  },
  thumb: {
    ...size(rem(24)),
    [`&:hover, &.${sliderClasses.focusVisible}, &.${sliderClasses.active}`]: {
      boxShadow: `0 0 0 ${rem(14)} ${alpha(theme.customPalette.onElements.selected || '', 0.5)}`,
    },
    [`&.${sliderClasses.disabled}`]: {
      color: theme.palette.text.disabled,
    },
    color: theme.palette.primary.main,
  },
  track: {
    borderRadius: RADIUS_1,
    border: 'none',
    color: theme.palette.primary.main,
  },
})
